import { useMutation } from '@urql/vue';
import { defineStore, storeToRefs } from 'pinia';

import { setAnimationsEnabled } from '~/graphql/documents/core';

export const useAccessibilityStore = defineStore('accessibilityStore', () => {
  const { user } = storeToRefs(useAuthStore());

  const animationsEnabled = ref(true);

  const { executeMutation: _setAnimationsEnabled } = useMutation(setAnimationsEnabled);

  watch(
    user,
    (newUser, oldUser) => {
      if (!oldUser && newUser && !newUser.animationsEnabled) {
        animationsEnabled.value = false;
      }
    },
    { immediate: true },
  );

  /** Applies and saves the setting, putting the old value back when the save fails. */
  const setAnimationSetting = async (enabled: boolean) => {
    const previous = animationsEnabled.value;
    animationsEnabled.value = enabled;
    const { error } = await _setAnimationsEnabled({ animationsEnabled: enabled });
    if (error) {
      animationsEnabled.value = previous;
    }
    return error ?? null;
  };

  return { animationsEnabled, setAnimationSetting };
});
